// extracted by mini-css-extract-plugin
module.exports = {"container":"EntryForm_container__EtoHb","distributedRow":"EntryForm_distributedRow__3H6Tf","footer":"EntryForm_footer__i_5i7"};